import type { DisputeApi, DisputesSummaryApi } from "@/types/api/disputes";
import type { DisputeUI, DisputesKpisUI } from "@/types/ui/disputes";

export function mapDisputeApiToUi(apiDispute: DisputeApi): DisputeUI {
  return {
    id: apiDispute.disputeNumber,
    customer: apiDispute.customer,
    customerId: apiDispute.customerId,
    type: apiDispute.type,
    amount: apiDispute.amount,
    status: apiDispute.status,
    priority: apiDispute.priority,
    assignedTo: apiDispute.assignedTo ?? "",
    createdDate: apiDispute.createdDate,
    dueDate: apiDispute.dueDate ?? "",
    workflow: apiDispute.workflow ?? "",
    aiScore: apiDispute.aiScore ?? null,
    aiRecommendation: apiDispute.aiRecommendation ?? "",
    currentLevel: apiDispute.currentLevel,
    totalLevels: apiDispute.totalLevels,
    description: apiDispute.description ?? "",
    resolutionNotes: apiDispute.resolutionNotes ?? "",
  };
}

export function mapSummaryToKpis(summary: DisputesSummaryApi): DisputesKpisUI {
  return {
    totalDisputes: summary.totalDisputes,
    totalAmount: summary.totalAmount,
    newCount: summary.newCount,
    inProgressCount: summary.inProgressCount,
    resolvedCount: summary.resolvedCount,
    highPriorityCount: summary.highPriorityCount,
  };
}
